import { Transition } from '@headlessui/react';
import { X } from '@phosphor-icons/react';
import { twJoin, twMerge } from 'tailwind-merge';
import MUIModal from '@mui/material/Modal';
import Button from '@/components/Button';

const variants = {
  primary: 'border-t-pv-primary-primary-500',
  warning: 'border-t-pv-warning-warning-text',
};

export const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  header,
  showHeader = true,
  className,
  headerClassName,
  titleClassName,
  closeClassName,
  childClassName,
  topBorderClassname = '',
  transition = true,
  showCloseBtn = true,
  opacity = 50,
  topStripClassName,
  center = true,
  showBlackDrop = true,
  styles = {},
  isMUIModal = false,
  containerClassname = '',
  classes = {},
  variant = 'primary',
}) => {
  const modalStyle = center
    ? { marginLeft: 'auto', marginRight: 'auto' } // Centered
    : { marginLeft: 'calc(36%)' }; // 25% right of center

  const Component = isMUIModal ? MUIModal : Transition;

  return (
    <Component
      {...(isMUIModal && {
        open: isOpen,
        onClose,
      })}
      show={isOpen}
      enter={transition ? 'transition-opacity duration-300' : ''}
      enterFrom={transition ? 'opacity-0' : ''}
      enterTo={transition ? 'opacity-100' : ''}
      leave={transition ? 'transition-opacity duration-300' : ''}
      leaveFrom={transition ? 'opacity-100' : ''}
      leaveTo={transition ? 'opacity-0' : ''}
      classes={{
        ...classes,
        backdrop: '!bg-[#44444466]',
      }}
    >
      <div
        className={twJoin(
          'fixed',
          !isMUIModal &&
            'inset-0 z-10 flex items-center justify-center w-full h-full',
          isMUIModal &&
            'top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2',
          isMUIModal && containerClassname && containerClassname
        )}
      >
        {showBlackDrop && (
          <div
            className={`fixed inset-0 bg-black bg-opacity-${opacity}`}
            onClick={onClose}
          />
        )}
        <div
          style={{ ...modalStyle, ...(styles?.modal || {}) }}
          className={twMerge(
            'bg-white w-96 rounded-xl shadow-xl z-50',
            className,
            variants[variant],
            topBorderClassname
          )}
        >
          <div
            className={twMerge(
              'bg-brand-ai-100 h-1.5 rounded-t-3xl',
              topStripClassName
            )}
          />
          {showHeader && (
            <div
              className={twMerge(
                'flex items-center relative justify-between px-8 pt-6 pb-4',
                headerClassName
              )}
            >
              {header && <div className="w-full">{header}</div>}
              <h2 className={twMerge('text-lg font-medium', titleClassName)}>
                {title}
              </h2>
              {showCloseBtn && (
                <Button
                  className={{
                    button: {
                      root: twMerge(
                        'p-0 grid place-items-center w-7 absolute right-7 top-7',
                        closeClassName
                      ),
                    },
                  }}
                  onClick={onClose}
                >
                  <X size={16} className="text-pv-neutral-grey-400" />
                </Button>
              )}
            </div>
          )}
          <div className={childClassName}>{children}</div>
        </div>
      </div>
    </Component>
  );
};
